import { z } from 'zod';

import { findDuplicateIds, findDuplicateNames } from '../../base/primitives';
import { KnowledgeBaseSchema } from './knowledge-base.schema';

export const KnowledgeBaseCollectionSchema = KnowledgeBaseSchema.superRefine(
  (data, ctx) => {
    const topics = Object.values(data.topics.entities).filter(
      topic => topic.isActive,
    );
    const duplicateNames = findDuplicateNames(topics);
    const duplicateIds = findDuplicateIds(topics);

    for (const duplicate of duplicateNames) {
      ctx.addIssue({
        path: ['topics', 'entities', duplicate.id, 'name'],
        code: z.ZodIssueCode.custom,
        message: 'Duplicate name',
      });
    }

    for (const duplicate of duplicateIds) {
      ctx.addIssue({
        path: ['topics', 'entities', duplicate.id, 'id'],
        code: z.ZodIssueCode.custom,
        message: 'Duplicate ID',
      });
    }
  },
).describe(
  'Knowledge Base domain - Document storage and retrieval for RAG (Retrieval-Augmented Generation). ' +
    'The knowledge base stores documents, FAQs, policies, and other reference content that the AI can query to answer questions. ' +
    'Uses vector embeddings for semantic search and similarity matching. ' +
    'Relationships: Referenced by flows and topics when the AI needs to look up information to answer questions. ' +
    'Independent of other domains but provides context for conversations. ' +
    "Use the 'knowledge-base' domain in MCP to see document schemas and retrieval configuration.",
);

export type KnowledgeBaseCollection = z.infer<
  typeof KnowledgeBaseCollectionSchema
>;
